"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mockedListCarousel = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
const mockedListCarousel = exports.mockedListCarousel = {
    __typename: 'EditorialLinkCarousel',
    id: 'dc8dc77b-f144-4371-8f99-866b94605949',
    title: 'Main title',
    linkItems: [
        {
            imageUrl: 'https://media-uat-cdn.oriflame.com/contentImage?externalMediaId=bac023cc-345c-40ab-be3f-2a6e38dea69c&name=Apple&inputFormat=png',
            __typename: 'EditorialLinkListItem',
            downloadable: false,
            title: 'Link title 1',
            link: {
                __typename: 'Link',
                id: 'https://google.com',
                relativeUrl: 'https://google.com',
                title: '',
                type: _editorialFetching.LinkType.Custom,
                appLink: null
            }
        },
        {
            imageUrl: 'https://media-uat-cdn.oriflame.com/contentImage?externalMediaId=bac023cc-345c-40ab-be3f-2a6e38dea69c&name=Apple&inputFormat=png',
            __typename: 'EditorialLinkListItem',
            downloadable: false,
            title: 'Link title 2',
            link: {
                __typename: 'Link',
                id: 'https://google.com',
                relativeUrl: 'https://google.com',
                title: '',
                type: _editorialFetching.LinkType.Custom,
                appLink: null
            }
        },
        {
            imageUrl: 'https://media-uat-cdn.oriflame.com/contentImage?externalMediaId=bac023cc-345c-40ab-be3f-2a6e38dea69c&name=Apple&inputFormat=png',
            __typename: 'EditorialLinkListItem',
            downloadable: false,
            title: 'Link title 3',
            link: {
                __typename: 'Link',
                id: 'https://google.com',
                relativeUrl: 'https://google.com',
                title: '',
                type: _editorialFetching.LinkType.Custom,
                appLink: null
            }
        },
        {
            imageUrl: 'https://media-uat-cdn.oriflame.com/contentImage?externalMediaId=bac023cc-345c-40ab-be3f-2a6e38dea69c&name=Apple&inputFormat=png',
            __typename: 'EditorialLinkListItem',
            downloadable: false,
            title: 'Link title 4',
            link: {
                __typename: 'Link',
                id: 'https://google.com',
                relativeUrl: 'https://google.com',
                title: '',
                type: _editorialFetching.LinkType.Custom,
                appLink: null
            }
        },
        {
            imageUrl: 'https://media-uat-cdn.oriflame.com/contentImage?externalMediaId=bac023cc-345c-40ab-be3f-2a6e38dea69c&name=Apple&inputFormat=png',
            __typename: 'EditorialLinkListItem',
            downloadable: false,
            title: 'Link title 5',
            link: {
                __typename: 'Link',
                id: 'https://google.com',
                relativeUrl: 'https://google.com',
                title: '',
                type: _editorialFetching.LinkType.Custom,
                appLink: null
            }
        },
        {
            imageUrl: 'https://media-uat-cdn.oriflame.com/contentImage?externalMediaId=bac023cc-345c-40ab-be3f-2a6e38dea69c&name=Apple&inputFormat=png',
            __typename: 'EditorialLinkListItem',
            downloadable: false,
            title: 'Link title 6',
            link: {
                __typename: 'Link',
                id: 'https://google.com',
                relativeUrl: 'https://google.com',
                title: '',
                type: _editorialFetching.LinkType.Custom,
                appLink: null
            }
        },
        {
            imageUrl: 'https://media-uat-cdn.oriflame.com/contentImage?externalMediaId=bac023cc-345c-40ab-be3f-2a6e38dea69c&name=Apple&inputFormat=png',
            __typename: 'EditorialLinkListItem',
            downloadable: false,
            title: 'Link title 7',
            link: null
        },
        {
            imageUrl: 'https://media-uat-cdn.oriflame.com/contentImage?externalMediaId=bac023cc-345c-40ab-be3f-2a6e38dea69c&name=Apple&inputFormat=png',
            __typename: 'EditorialLinkListItem',
            downloadable: false,
            title: 'Link title 8',
            link: {
                __typename: 'Link',
                id: 'https://google.com',
                relativeUrl: 'https://google.com',
                title: '',
                type: _editorialFetching.LinkType.Custom,
                appLink: null
            }
        },
        {
            imageUrl: 'https://media-uat-cdn.oriflame.com/contentImage?externalMediaId=bac023cc-345c-40ab-be3f-2a6e38dea69c&name=Apple&inputFormat=png',
            __typename: 'EditorialLinkListItem',
            downloadable: false,
            title: 'Link title 9',
            link: {
                __typename: 'Link',
                id: 'https://google.com',
                relativeUrl: 'https://google.com',
                title: '',
                type: _editorialFetching.LinkType.Custom,
                appLink: null
            }
        }
    ]
};
